import { useCallback } from 'react';
import { ProjectParameters } from 'ducks/types/store-types';

export const useScrubParameters = () => {
  const scrubParameters = useCallback((params: ProjectParameters) => {
    const scrubbed = params.filter((parameter) => parameter.modified);
    return {
      create: scrubbed.filter((scrub) => !scrub.saved && !scrub.delete),
      update: scrubbed.filter((scrub) => scrub.saved && !scrub.delete),
      delete: scrubbed.filter((scrub) => scrub.saved && scrub.delete),
    };
  }, []);

  return { scrubParameters };
};
